module.exports = __webpack_public_path__ + "static/media/logo.f653a0b9.png";